import * as React from 'react';
import { useKeyborg } from './useKeyborg';
/**
 */ export function useSetKeyboardNavigation() {
    const keyborg = useKeyborg();
    return React.useCallback((isNavigatingWithKeyboard)=>{
        keyborg === null || keyborg === void 0 ? void 0 : keyborg.setVal(isNavigatingWithKeyboard);
    }, [
        keyborg
    ]);
}
